__turbopack_context__.v({
  "checked": "Radio-module__qyJKnW__checked",
  "description": "Radio-module__qyJKnW__description",
  "disabled": "Radio-module__qyJKnW__disabled",
  "group": "Radio-module__qyJKnW__group",
  "horizontal": "Radio-module__qyJKnW__horizontal",
  "indicator": "Radio-module__qyJKnW__indicator",
  "input": "Radio-module__qyJKnW__input",
  "label": "Radio-module__qyJKnW__label",
  "labelText": "Radio-module__qyJKnW__labelText",
  "radio": "Radio-module__qyJKnW__radio",
  "radioWrapper": "Radio-module__qyJKnW__radioWrapper",
  "vertical": "Radio-module__qyJKnW__vertical",
});
